module.exports = __webpack_public_path__ + "static/media/weixin-nj.84d69214.jpg";